import { isPlainObject, pickBy } from 'lodash-es';

export const localStorageKeys = {
  printMapTiles: 'print-map-tile',
  ign: 'use-ign-tiles',
  state: 'state',
  drivers: 'drivers',
  equipments: 'equipments',
  parcels: 'parcels',
  tracks: 'tracks',
  observations: 'observations',
  parcelsName: 'parcelsName',
  allParcels: 'allParcels',
  colorizeFieldsBy: 'colorize-fields-by',
  colorizeTracksBy: 'colorize-tracks-by',
  forcePageRefresh: 'page-has-been-force-refreshed',
  showMarkerClusters: 'show-marker-clusters',
  dateRange: 'date-range',
  dateRangeMeta: 'date-range-meta',
  reportEquipmentSort: 'report-equipment-sort',
  taskClientReportSelection: 'task-client-report-selection',
  taskArticleReportSelection: 'task-article-report-selection',
  planningClusterSelection: 'planning-cluster-selection',
  planningDisplayOptions: 'planning-display-options',
  bookingClusterSelection: 'booking-cluster-selection',
  maintenanceClusterSelection: 'maintenance-cluster-selection',
  dashboardWorksiteDimension: 'dashboard-worksite-dimension',
  dashboardClusterDimension: 'dashboard-cluster-dimension',
} as const;

/**
 * The value stored under `key`, read as the type of `defaultValue`: strings are stored as they are and everything else
 * as JSON, an object keeps only the stored fields of the type its default gives them, and anything missing or
 * unreadable falls back to the default
 */
export function readStoredValue<T>(key: string, defaultValue: T): T {
  const stored = localStorage.getItem(key);
  if (stored === null) return defaultValue;
  if (typeof defaultValue === 'string') return stored as T;

  try {
    const parsed: unknown = JSON.parse(stored);
    if (isPlainObject(defaultValue)) {
      const defaults = defaultValue as Record<string, unknown>;
      return isPlainObject(parsed)
        ? ({ ...defaults, ...pickBy(parsed as object, (value, field) => typeof value === typeof defaults[field]) } as T)
        : defaultValue;
    }
    return defaultValue === null || typeof parsed === typeof defaultValue ? (parsed as T) : defaultValue;
  } catch {
    return defaultValue;
  }
}

export function writeStoredValue(key: string, value: unknown) {
  localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
}
